<template>
  <div class="page-column">
    <h2>带队成员审核名单</h2>
    <a-table :columns="columns" :data-source="data" :pagination="false" bordered>
      <template slot="name" slot-scope="text">
        <a>{{ text }}</a>
      </template>
      <template slot="title" slot-scope="currentPageData">
        搜索：<a-input-search placeholder="请输入名字或者身份证搜索" style="width: 300px" @search="onSearch" />
        <a-radio-group @change="changeStatus" v-model="valData.status" style="margin-bottom: 16px">
          <a-radio-button :value="-1">
            全部
          </a-radio-button>
          <a-radio-button :value="0">
            未审核
          </a-radio-button>
          <a-radio-button :value="1">
            审核通过
          </a-radio-button>
          <a-radio-button :value="2">
            审核未通过
          </a-radio-button>
        </a-radio-group>
        <a-pagination style="float: right;" v-if="data.length > 0" v-model="current" @change="pageData" :total="total" :pageSize="valData.pageSize" show-less-items />
      </template>
      <template slot="sex" slot-scope="text, record">
        <a-tag v-if="text === 2" color="pink">女</a-tag>
        <a-tag v-if="text === 1" color="blue">男</a-tag>
      </template>
      <template slot="type" slot-scope="text, record">
        <a-tag color="blue">{{ matchFun.getLeaderName2(record.type) }}</a-tag>
      </template>
      <template slot="validityDate" slot-scope="text, record">
        <template v-if="text">培训证书有效期：{{ text }}</template>
        <template v-if="record.certificate">培训合格证书：<a :href="record.certificate" target="_blank"><img :src="record.certificate" style="width:32px;height:32px;"></a></template>
        <template v-if="record.workImg">工作证：<a :href="record.workImg" target="_blank"><img :src="record.workImg" style="width:32px;height:32px;"></a></template>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="text === 0">未审核</a-tag>
        <a-tag v-if="text === 1" color="#87d068">通过</a-tag>
        <a-tag v-if="text === 2" color="#f50">不通过【驳回信息：{{ record.msg }}】</a-tag>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-popconfirm
          title="确定审查通过吗?"
          @confirm="() => check(record.id, 1)"
        >
          <a-button type="primary" icon="check">通过</a-button>
        </a-popconfirm>
        <a-popover title="不通过，请填写原因" trigger="click">
          <template slot="content">
            <a-input placeholder="请输入不通过的原因" v-model="record.msg"/><br/><br/>
            <a-button type="primary" @click="checkMsg(record, 2)">
              提交
            </a-button>
          </template>
          <a-button type="danger" icon="close">不通过</a-button>
        </a-popover>
      </template>
    </a-table>
    
  </div>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
export default {
  components: {
  },
  data() {
    return {
      matchFun,
      columns: [
        {
          title: '序号',
              dataIndex: 'index',
              key: 'index',
              width: 80,                    
              fixed: 'left',
              customRender: (text,record,index) => `${(this.current*1-1)*this.valData.pageSize*1 + (index+1)}`, // 关键句
        },
        {
          title: '机构名称',
          dataIndex: 'agencyName',
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '身份证',
          dataIndex: 'card',
        },
        {
          title: '性别',
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
        },
        {
          title: '职称',
          dataIndex: 'protitle',
        },
        {
          title: '专业',
          dataIndex: 'educational',
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
        },
        {
          title: '人员类别',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '培训证书有效期',
          dataIndex: 'validityDate',
          scopedSlots: { customRender: 'validityDate' },
        },
        {
          title: '审核状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data: [],
      current: 1,
      valData: {
        pageNum: 1, 
        pageSize: 10,
        status: -1,
        keyword: ''
      },
      total: 0
    }
  },
  mounted () {
    document.title = '道吧网 | 组委会 | 单位名单管理'
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.manageStaffList(this.valData).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.total = res.total
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    changeStatus (e) {
      console.log(e)
      this.valData.status = e.target.value
      this.valData.pageNum = 1
      this.findData()
    },
    pageData (page) {
      this.valData.pageNum = page
      this.findData()
    },
    onSearch (e) {
      console.log(e)
      this.valData.pageNum = 1
      this.valData.keyword = e
      this.findData()
    },
    check (id, status) {
      this.$api.match.staffCheckMsg({id: id, status: status}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
    checkMsg (record, status) {
      if (!record.msg || record.msg === '') {
        this.$message.error(`请填写不通过的原因`)
        return
      }
      this.$api.match.staffCheckMsg({id: record.id, status: status, msg: record.msg}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 20px;
  .content {
    position: relative;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/organizing/Staff.vue